<div class="container-modal-lateral">
  <div>
    <span class="title-modal-lateral">{{ isFiltro ? "Filtrar" : isVisualizacao ? "Detalhes da sessão" : "Trocas" }}</span>

    @if (isFiltro) {
      <div class="main-modal-lateral-edicao">
        <app-select-one
          class="width-100"
          heightFormField="36px"
          placeholder="Selecione a atividade"
          [listaInput]="atividadeOpcoes"
          [itemSelecionado]="atividadeSelecionada"
          (selecionarItem)="atividadeSelecionada = $event"
          backgroundColor="rgba(221, 188, 255, 0.1)"
          label="Atividade"
          campo="nome"
          colorLabel="black"
        ></app-select-one>

        <app-select-multiple
          class="width-100"
          [listaInput]="fluxosSelect"
          [itensSelecionado]="filtrosObj.fluxos"
          heightFormField="36px"
          campo="titulo"
          (selecionarItem)="filtrosObj.fluxos = $event"
          colorLabel="black"
          label="Fluxo"
          [carregandoInfo]="carregandoFluxos"
          [isMobile]="validarMobile()"

        ></app-select-multiple>

        <app-select-multiple
          class="width-100"
          [listaInput]="operadores"
          [itensSelecionado]="filtrosObj.operadores"
          heightFormField="36px"
          campo="nome"
          (selecionarItem)="filtrosObj.operadores = $event"
          colorLabel="black"
          label="Operadores"
          [carregandoInfo]="carregandoOperadores"
          [isMobile]="validarMobile()"
        ></app-select-multiple>

        <app-form-field
          class="width-100"
          label="Período data de abertura"
          heightFormField="36px"
          placeholder="Selecione um período de data de abertura"
          widthFormField="100%"
          [isDateRange]="true"
          [dataInicio]="filtrosObj.dataAberturaInicio"
          (dataInicioChange)="filtrosObj.dataAberturaInicio = $event"
          [dataFim]="filtrosObj.dataAberturaFim"
          (dataFimChange)="filtrosObj.dataAberturaFim = $event"
          [backgroundColor]="'rgba(221, 188, 255, 0.1)'">
        </app-form-field>
      </div>
    }
    @else {
      @if (isVisualizacao) {
        <div class="main-modal-lateral-info">
          <div class="container-info-modal-lateral">
            <span class="label">Fluxo</span>
            <span class="font-12 weight-300">{{sessao.fluxo && sessao.fluxo.nome ? sessao.fluxo.nome : 'Sem fluxo' }}</span>
          </div>

          <div class="container-info-modal-lateral">
            <span class="label">Etapa</span>
            <span class="font-12 weight-300">{{sessao.etapa && sessao.etapa.titulo ? sessao.etapa.titulo : 'Sem etapa' }}</span>
          </div>

          <div class="container-info-modal-lateral">
            <span class="label">Tempo para finalização</span>
            <app-progress-bar-data [width]="'100%'" [left]="'50%'" [data]="sessao.dataFormatadaFinalizar || ''" [tempoFinalizar]="sessao.tempoFinalizar ?? 0" [verificaFinalizada]="true" height="20px"></app-progress-bar-data>
          </div>

          <div class="container-info-modal-lateral">
            <span class="label">Nome contato</span>
            <span class="font-12 weight-300 ellipse">{{sessao.contato ? sessao.contato.nome : 'Sem nome' }}</span>
          </div>

          <div class="container-info-modal-lateral">
            <span class="label">Número contato</span>
            <span class="font-12 weight-300 ellipse">{{sessao.contato ? sessao.contato.numero : 'Sem número' }}</span>
          </div>

          <div class="container-info-modal-lateral">
            <span class="label">Canal</span>
            <span class="font-12 weight-300">{{sessao.canal ? sessao.canal.nome : 'Sem canal' }}</span>
          </div>

          <div class="container-info-modal-lateral">
            <span class="label">Operador</span>
            <span class="font-12 weight-300">{{sessao.operador ? sessao.operador.nome : 'Sem operador' }}</span>
          </div>
        </div>

        <div class="topico-modal-lateral">
          <span class="label">Tags</span>
        </div>

        <div class="main-modal-lateral-info gap-15 flex-row wrap">
          @for (tag of sessao.tags; track $index) {
            <span class="tags">{{ tag }}</span>
          }
        </div>

        <div class="topico-modal-lateral">
          <span class="label">Variáveis</span>
        </div>

        <div class="main-modal-lateral-info gap-15">
          @for (variavel of variaveis; track $index) {
            <div class="flex-row gap-5">
              <span class="font-12 weight-700">{{ variavel.nome }}: </span>
              <span class="font-12 weight-700 color-primary">[{{ variavel.valor }}]</span>
            </div>
          }
        </div>
      }
      @else {
        <div>
          <app-card-sessao-mobile [sessao]="sessao" [isExibicao]="true"></app-card-sessao-mobile>
        </div>

        <div class="topico-modal-lateral" style="margin-top: 20px">
          <span class="label">Ações</span>
        </div>

        <div class="main-modal-lateral-info gap-15">
          @if (sessao.ativo) {
            <app-select-one
              class="width-100"
              heightFormField="36px"
              placeholder="Selecione o canal"
              [listaInput]="canais"
              [itemSelecionado]="sessao.canal"
              (selecionarItem)="selecionarCanal($event); sessao.operador = undefined"
              backgroundColor="rgba(221, 188, 255, 0.1)"
              label="Selecione o Canal"
              campo="nome"
              colorLabel="black"
              [carregandoInfo]="carregandoCanais"
            ></app-select-one>

            <app-select-one
              class="width-100"
              heightFormField="36px"
              placeholder="Selecione a operador"
              [listaInput]="operadores"
              [itemSelecionado]="sessao.operador"
              (selecionarItem)="sessao.operador = $event"
              backgroundColor="rgba(221, 188, 255, 0.1)"
              label="Transferir Operador"
              campo="nome"
              colorLabel="black"
              [carregandoInfo]="carregandoOperadores"
            ></app-select-one>
          }

          <app-select-one
            class="width-100"
            heightFormField="36px"
            placeholder="Selecione a fluxo"
            [listaInput]="fluxosSelect"
            [itemSelecionado]="sessao.fluxo"
            (selecionarItem)="selecionarFluxo($event); sessao.etapa = undefined"
            backgroundColor="rgba(221, 188, 255, 0.1)"
            label="Mudar fluxo"
            campo="titulo"
            colorLabel="black"
            [carregandoInfo]="carregandoFluxos"
          ></app-select-one>

          <app-select-one
            class="width-100"
            heightFormField="36px"
            placeholder="Selecione a etapa"
            [listaInput]="etapasSelect"
            [itemSelecionado]="sessao.etapa"
            (selecionarItem)="selecionarEtapa($event);"
            backgroundColor="rgba(221, 188, 255, 0.1)"
            label="Mudar etapa"
            campo="titulo"
            colorLabel="black"
            [carregandoInfo]="carregandoEtapas"
          ></app-select-one>
        </div>
      }
    }
  </div>

  @if (!isVisualizacao ) {
    <div class="botoes-modal-lateral">
      <app-button-padrao
        width="100%"
        label="{{ isFiltro ? 'Filtrar' : 'Salvar' }}"
        borderRadius="8px"
        backgroundColor="var(--verde-padrao)"
        color="white"
        (buttonClick)="salvar()"
      ></app-button-padrao>
      @if(!isFiltro && sessao.ativo){
        <app-button-padrao
          iconSrc="icones/xmark-retangulo 2"
          iconSrcExtensao=".svg"
          widthIcon="22px"
          heightIcon="22px"
          borderRadius="8px"
          width="100%"
          label="Encerrar sessão"
          backgroundColor="var(--vermelho-padrao)"
          color="white"
          (buttonClick)="inativarSessao()"
        ></app-button-padrao>
      }
      <app-button-padrao
        width="100%"
        label="Cancelar"
        backgroundColor="white"
        color="var(--vermelho-padrao)"
        borderRadius="8px"
        (buttonClick)="cancelar()"
        borderColor="var(--vermelho-padrao)"
        borderStyle="solid"
        borderWidth="1px"
      ></app-button-padrao>
    </div>
  }
</div>
